import React from 'react';
import { Tabs } from './tabs';

export function MDFTabs(props: any) {
  const { data, ...tabProps } = props;

  return <Tabs { ...tabProps } data={data && data.length ? data.filter((item) => !item.hidden) : data}/>;
}
